import { EditableBadgeAddButton } from './EditableBadgeAddButton'
import { EditableBadgeItem } from './EditableBadgeItem'
import { EditableBadgeRawItem } from './EditableBadgeRawItem'
import { EditableBadgeRoot } from './EditableBadgeRoot'

export const EditableBadge = {
  AddButton: EditableBadgeAddButton,
  Item: EditableBadgeItem,
  RawItem: EditableBadgeRawItem,
  Root: EditableBadgeRoot,
}
